import { graphql } from 'gatsby';

export const PricingSliceFragment = graphql`
    fragment PrismicPricingFragment on PRISMIC_PageBodyPricing {
        type
        primary {
            pricing_table {
                ...PrismicPricingTableFragment
            }
            pricing_title
        }
    }

    fragment PrismicPricingTableFragment on PRISMIC_Pricing_table {
        toggle_monthly
        toggle_yearly
        per_month
        per_year
        billed_yearly
        yearly_upsell
        save
        free
        best_recommended
        save_up_to
        on_yearly_plans
        saving_yearly
        mastering_features_name
        tabs {
            tab {
                ...PrismicPartialPricingTabFragment
            }
        }
    }

    fragment PrismicPartialPricingTabFragment on PRISMIC_Pricing_tab {
        _meta {
            uid
        }
        name
    }
`;

// Split into a separate variable to avoid including it in the main query sent to Prismic during preview fetching.
// Including it caused us to bust the max length of the preview's GraphQL GET request!!!
export const PricingTabFragment = graphql`
    fragment PrismicPricingTabFragment on PRISMIC_Pricing_tab {
        _meta {
            uid
        }
        name
        frequencies_available
        plans {
            plan {
                ...PrismicPricingPlanFragment
            }
        }
    }

    fragment PrismicPricingPlanFragment on PRISMIC_Pricing_plan {
        name
        pricing_description
        pricing_cta
        pricing_cta_link {
            ...LinkFragment
        }
        products {
            product {
                ...PrismicPricingPlanProductFragment
                ...PrismicPricingPlanFeatureFragment
            }
        }
        api_plan
    }

    fragment PrismicPricingPlanProductFragment on PRISMIC_Pricing_plan_product {
        _meta {
            uid
        }
        name
        unlimited_text
        discount_text
        api_product
        tooltip
    }

    fragment PrismicPricingPlanFeatureFragment on PRISMIC_Pricing_plan_feature {
        _meta {
            uid
        }
        title
        sub_features {
            label
            tooltip
        }
    }
`;
